let user = {
  name: 'user',
  path: 'user',
  // redirect: "/user/index",
  component: () => import('@/views/user/index.vue'),
  meta: {
    name: '用户'
  },
  children: [
    {
      path: '/user/index',
      name: 'userindex',
      component: () => import('@/views/user/pages/index.vue'),
      meta: {
        name: '用户'
      }
    },
    {
      path: 'userDetail/:userId',
      name: 'detailIndex',
      component: () => import('@/views/user/pages/userDetail.vue'),
      meta: {
        name: '用户详情'
      }
    },
    {
      path: '/user/importUser/add',
      name: 'importUserAdd',
      component: () => import('@/views/user/pages/importUser/add.vue'),
      meta: {
        name: '新建导入'
      }
    },
    {
      path: '/user/importUser/detail/:id',
      name: 'importUserDetail',
      component: () => import('@/views/user/pages/importUser/detail.vue'),
      meta: {
        name: '导入详情'
      }
    },
    {
      path: '/user/group/add',
      name: 'groupAdd',
      component: () => import('@/views/user/pages/group/add.vue'),
      meta: {
        name: '新建用户分群'
      }
    },
    {
      path: '/user/group/detail/:id',
      name: 'groupDetail',
      component: () => import('@/views/user/pages/group/detail.vue'),
      meta: {
        name: '用户分群详情'
      }
    }
  ]
}

export default user
